import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { EmailSourceType } from '../../../enums/enums'
import { ContactsFormType, ContactsService } from '../../../services/contacts.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-contacts-form',
  templateUrl: './bmcore-contacts-form.component.html',
  styleUrls: ['./bmcore-contacts-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreContactsFormComponent implements OnInit {
  @Input() beatmakerId: number
  @Input() emailSecret: string
  @Input() routerPath = ''
  @Input() sourceType: EmailSourceType

  lg: LgType
  contactsForm: UntypedFormGroup
  pageMode = false
  isLoader = false

  constructor(
    private contactsService: ContactsService,
    private i18nService: I18nService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.defineContactsPageMode()
    this.lg = this.i18nService.getLanguageForPage()

    this.contactsForm = this.formBuilder.group({
      email: [],
      name: [],
      message: []
    })
  }

  defineContactsPageMode() {
    if (this.routerPath.includes('contacts')) {
      this.pageMode = true
    }
  }

  onSubmit() {
    const data: ContactsFormType = {
      contacts: this.contactsForm.value.email.email,
      subject: this.contactsForm.value.name.name,
      message: this.contactsForm.value.message.message,
      userId: this.beatmakerId,
      secret: this.emailSecret,
      sourceType: this.sourceType
    }

    this.sendMessage(data)
  }

  sendMessage(data: ContactsFormType) {
    if (this.contactsForm.valid) {
      this.isLoader = true

      this.contactsService
        .sendMessage(data)
        .pipe(finalize(() => (this.isLoader = false)))
        .subscribe(
          res => {
            if (res.resultCode === ResultCode.Success) {
              this.notificationService.handleSuccess(this.lg.forms.successMessage)
            } else {
              this.notificationService.handleError(res.messages[0])
            }
            this.contactsForm.reset()
          },
          err => this.notificationService.handleError(err.message)
        )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
